import {GET_COMPARE_BODIES_BY_SECTION_ID} from '../../../actions/actiontypes';

export function aresCompareBodiesReducer(store = {}, action) {
	switch (action.type) {
		case GET_COMPARE_BODIES_BY_SECTION_ID:
			return action.response;
		default:
			return store;
	}
}
